import { getUser, setUser } from '@utsubo/experience'
import { emitEvent, useEvent } from '@utsubo/events'

import { getDocument, updateDocument } from '@/helpers/firebase/api'
import { structuredCloneSafe } from '@/helpers/structuredCloneSafe'

function merge(obj1, obj2) {
  // Create a new object to hold the merged values
  const merged = structuredCloneSafe(obj1)

  // Loop through all the properties of obj2
  for (const [key, value] of Object.entries(obj2)) {
    // If the property exists in both objects and is an object, recursively merge the objects
    if (key in merged && isObject(value) && isObject(merged[key])) {
      merged[key] = merge(merged[key], value)
    } else {
      // Otherwise, simply add or overwrite the property in the merged object
      merged[key] = structuredCloneSafe(value)
    }
  }

  return merged
}

function isObject(obj) {
  return obj != null && typeof obj === 'object'
}

// private functions
const emitUpdate = (data) => {
  if (!data || data === null) return

  Object.keys(data).forEach((key) => {
    const field = data[key]
    if (typeof field === 'object') {
      Object.keys(data[key]).forEach((subkey) => {
        const value = data[key][subkey]

        emitEvent(`update_${key}_${subkey}`, value)
        Object.keys(data[key][subkey]).forEach((subsubkey) => {
          const subvalue = data[key][subkey][subsubkey]
          emitEvent(`update_${key}_${subkey}_${subsubkey}`, subvalue)
        })
      })
    } else {
      emitEvent(`update_${key}`, field)
    }
  })

  //DEEP MERGE TO AVOID BUGS OF ALL THE USER SETTINGS
  setUser({
    settings: merge(getUser().settings, data),
  })
}

export const SettingsAPI = ({ withFirestore }) => {
  useEvent('setSettings', async (settings) => {
    emitUpdate(settings)
    if (withFirestore) {
      await updateDocument(`users/${getUser().id}/private/settings`, settings)
    }
  })
  return null
}

export const getSettings = async (id) => {
  const settings = await getDocument(`/users/${id}/private/settings`)
  emitUpdate(settings)

  return 'ok'
}
